export default __webpack_public_path__ + "static/media/TF_23.350cad54.png";